/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DashboardDto } from '../../models/dashboard-dto';

export interface DashboardsGet$Json$Params {
  search?: string;
  includeTiles?: boolean;
}

export function dashboardsGet$Json(http: HttpClient, rootUrl: string, params?: DashboardsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DashboardDto>>> {
  const rb = new RequestBuilder(rootUrl, dashboardsGet$Json.PATH, 'get');
  if (params) {
    rb.query('search', params.search, {});
    rb.query('includeTiles', params.includeTiles, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DashboardDto>>;
    })
  );
}

dashboardsGet$Json.PATH = '/dashboards';
